<template>
  <div>
    <el-dialog
            title="结果提示"
            :visible.sync="correct"
            width="30%"
            :before-close="handleClose">
      <div class="answerResult" v-if="isAdopt === 'true'">您的成绩为{{achievement}}分，恭喜您通过{{this.$store.state.siteName}}线上培训考试，工作人员将会在3个工作日内进行资料审核，请您耐心等待哦</div>
      <div class="answerResult" v-if="isAdopt === 'false'">您的成绩为{{achievement}}分，很抱歉您未通过{{this.$store.state.siteName}}线上培训考试，请认真学习教程之后再进行答题哦</div>
      <span slot="footer" class="dialog-footer" v-if="isAdopt === 'true'">
        <el-button type="primary" @click="answerConfirm">确定</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="isAdopt === 'false'">
        <el-button @click="relearning">重新学习</el-button>
        <el-button type="primary" @click="answerAgain">再次答题</el-button>
      </span>
    </el-dialog>
    <div class="box760">
      <div class="steps flex justify-content align-items">
        <div class="item active justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">填写资料</p>
        </div>
        <div class="line line-ff9203"></div>
        <div class="item underway justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">达人培训</p>
        </div>
        <div class="line"></div>
        <div class="item justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">认证成功</p>
        </div>
      </div>
    </div>
    <div class="box760 white-bg shadow fromBox border" v-if="isShow === 'info'">
      <h3 class="attestation-title">请补充以下信息</h3>
      <div class="attestation-content">
        <el-form ref="darenFrom" :model="form" :rules="rules" label-width="200px" label-position="top">
          <el-form-item label="您的微信号" prop="wechat_number">
            <el-input v-model="form.wechat_number" placeholder="请输入您的微信号"></el-input>
          </el-form-item>
          <el-form-item label="您的微信好友数量" prop="wechat_friend_num">
            <el-input v-model="form.wechat_friend_num" placeholder="请输入您的微信好友数量"></el-input>
          </el-form-item>
          <el-form-item label="您是从哪里知道我们的" prop="source">
            <el-radio-group v-model="form.source" class="from-btn">
              <el-radio label="朋友推荐"></el-radio>
              <el-radio label="朋友圈"></el-radio>
              <el-radio label="微信群"></el-radio>
              <el-radio label="广告"></el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="请从以下选项中选择3个您的兴趣爱好标签" prop="label">
            <el-checkbox-group
                    v-model='form.label'
                    :max='3'>
              <el-checkbox v-for="city in form.tagList" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submission('darenFrom')" style="width: 100%;">确认提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!--补充信息-->
    <div class="box760 white-bg shadow fromBox border" v-if="isShow === 'course'">
      <h3 class="attestation-title">请仔细阅读新手教程，然后前往答题</h3>
      <div class="attestation-content">
        <div class="introduce" v-html="courseDate"></div>
        <el-button type="primary" style="width: 100%;margin-top:40px;" @click="goAnswer">已看完教程，信心满满去答题啦</el-button>
      </div>
    </div>
    <!--课程-->
    <div class="box760 white-bg shadow fromBox border" v-if="isShow === 'answer'">
      <h3 class="attestation-title">每题20分，共100分，80分即可通过</h3>
      <div class="attestation-content">
        <el-radio-group
                class="answerList"
                v-for="(item,index) in answerData"
                :key="index"
                v-model="item.option.value">
            <h3>{{item.title}}</h3>
<!--          {{item.option.value}}{{item.answer}}-->
            <el-radio
                    v-for="option in item.option"
                    :key="option.id"
                    :label="option.value">{{option.name}}</el-radio>

        </el-radio-group>
        <el-button type="primary" @click="confirmAnswer" style="width: 100%;">提交答题</el-button>
      </div>
    </div>
    <!--答题-->
  </div>
</template>
<script>
  import {
    savePcInfo,
    getConfig
  } from '@/config/api.js'
  const labelOptions = ['旅游','阅读','电影','美食','跳舞','K歌','游戏','摄影','DIY','购物','购房','玩车','看剧','运动/健身','美容美妆'];
  export default {
    name: 'Online',
    inject:['reload'],
    data () {
      return {
        form: {
          wechat_number: '',
          wechat_friend_num: '',
          source: '',
          label: [],
          tagList: labelOptions
        },
        answerData: [],
        isShow: 'info', //当前显示
        isAnswer: 1, //已答题
        courseDate: '',
        correct: false,
        achievement: '',
        isAdopt: 'false',
        fullscreenLoading: false,
        user_id: null,
        auth_type: 1,
        rules: {
          wechat_number: [
            { required: true, message: '请输入微信号'},
          ],
          wechat_friend_num: [
            { required: true, message: '请输入微信好友数量'},
          ],
          source: [
            { required: true, message: '请选择您是从哪里知道我们的', trigger: 'change' }
          ],
          label: [
            {required: true, message: '请选择兴趣爱好标签', trigger: 'change' }
          ]
        },
      }
    },
    methods: {
      submission (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid && this.form.label.length === 3) {
            this.$store.commit('changeWeChatNumber',this.form.wechat_number);
            this.$store.commit('changeWeChatFriendNum',this.form.wechat_friend_num);
            this.$store.commit('changeSource',this.form.source);
            this.$store.commit('changeLabel',this.form.label.join(','));
            this.$store.commit('changeIsInfo',1);
            setTimeout(() => {
              this.$message.success('成功提交信息');
              this.isShow = 'course'
            },1000)
          } else if (this.form.label.length < 3) {
            this.$message.error('至少要选择三个兴趣爱好标签')
          }
        });
      },
      getCourse () {
        let data = {
          key: 'pc_course'
        };
        this.$post(getConfig,data)
                .then(res => {
                  this.courseDate = res.data
                })
                .catch(err => {
                  window.console.log(err)
                })
      },
      goAnswer () {
        setTimeout(() => {
          this.isShow = 'answer'
        },1000)
      },
      getAnswer () {
        let data = {
          key: 'pc_questions'
        };
        this.$post(getConfig,data)
                .then(res => {
                  this.answerData = JSON.parse(res.data);
                  window.console.log(this.answerData);
                })
                .catch(err => {
                  window.console.log(err)
                })
      },
      confirmAnswer () {
        let num = 0;
        this.answerData.forEach(v => {
          if (v.option.value === v.answer) {
            this.num = ++num*20
          }else {
            this.num = this.num + 0
          }
        });
        if (this.num >= 80) {
          this.$store.commit('changeAuthType', this.auth_type);
          this.$store.commit('changeIsAnswer',this.isAnswer);
          this.confirmInfo();
          setTimeout(() => {
            this.correct = true;
            this.achievement = this.num;
            this.isAdopt = 'true';
          },1000);
        }else {
          setTimeout(() => {
            this.correct = true;
            if (isNaN(this.num)) {
              this.achievement = 0;
            }else {
              this.achievement = this.num;
            }
            this.isAdopt = 'false';
          },1000);
        }
      },
      confirmInfo () {
        let data = {
          user_id: Number(this.$store.state.user_id),
          auth_type: 1,
          wechat_number: this.$store.state.weChatNumber,
          wechat_group_num: JSON.stringify({
            friendCount: this.$store.state.weChatFriendNum,
            wechatGroupCount: '0',
            qinyou: '0',
            friend: '0',
            classmate: '0',
            hobby: '0',
            industry: '0',
            other: '0',
          }),
          source: this.$store.state.source,
          label: this.$store.state.label,
        };
        this.$post(savePcInfo,data)
                .then(() => {
                  this.$store.commit('changeAuthType',this.auth_type);
                  this.$store.commit('changeWeChatNumber','');
                  this.$store.commit('changeWeChatFriendNum','');
                  this.$store.commit('changeSource','');
                  this.$store.commit('changeLabel','')
                })
                .catch(err => {
                  this.$message.error(err.msg);
                })
      },
      answerConfirm () {
        this.$router.push('/daren-register/result')
      },
      handleClose () {
        this.$router.push('/daren-register/result')
      },
      relearning () {
        this.correct = false;
        this.isShow = 'course';
        this.$store.commit('changeIsAnswer',0);
        this.answerData.forEach(v => {
          v.option.value = ''
        });
        this.reload();
      },
      answerAgain () {
        this.correct = false;
        this.isShow = 'answer';
        this.$store.commit('changeIsAnswer',1);
        this.answerData.forEach(v => {
          v.option.value = ''
        });
        this.reload();
      },
      getInfo () {
    if (this.$store.state.isInfo === 1 && !this.$store.state.isAnswer) {
      this.isShow = 'course'
    } else if (this.$store.state.isAnswer === 1) {
      this.isShow = 'answer'
    } else {
      this.isShow = 'info'
    }
      },
      checkDaren () {
        if (this.$store.state.user_type !== 1) {
          this.$message.error('很抱歉，您不是达人用户，请注册认证！');
          this.$router.push('/')
        }
      }
    },
    created() {
      this.getCourse();
      this.getInfo();
      this.getAnswer();
      this.checkDaren();
    }
  }
</script>
<style>
  .from-btn .el-radio{margin-bottom:20px;}
  .answerList .el-radio{margin-bottom:20px;display: block;}
  .attestation-content .introduce img{max-width:100%;}
  .answerList{margin-bottom:40px;display: block;}
  .answerList h3{display: block;font-size: 14px;margin-bottom:20px;}
  .answerResult{line-height:30px;}
</style>
